import React from 'react';
import './DateInput.css';

/**
 * DateInput Component
 * Standardized date picker input
 * 
 * @param {string} label - Input label
 * @param {string} value - Date value (ISO format: YYYY-MM-DD)
 * @param {function} onChange - Change handler: (value: string) => void
 * @param {string} min - Minimum date (ISO format: YYYY-MM-DD)
 * @param {string} max - Maximum date (ISO format: YYYY-MM-DD)
 * @param {string} error - Error message
 * @param {boolean} disabled - Disabled state
 * @param {boolean} required - Required field indicator
 * @param {string} placeholder - Placeholder text
 * @param {string} helperText - Helper text below input
 * @param {string} className - Additional CSS classes
 */
const DateInput = ({
  label,
  value,
  onChange,
  min,
  max,
  error,
  disabled = false,
  required = false,
  placeholder,
  helperText,
  className = ''
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const inputId = `date-input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`date-input-container ${error ? 'error' : ''} ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="date-input-label">
          {label}
          {required && <span className="date-input-required">*</span>}
        </label>
      )}
      <input
        type="date"
        id={inputId}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        min={min}
        max={max}
        placeholder={placeholder}
        className={`date-input ${error ? 'error' : ''}`.trim()}
        aria-required={required}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined}
      />
      {(error || helperText) && (
        <div className="date-input-footer">
          {error && (
            <span id={`${inputId}-error`} className="date-input-error" role="alert">
              {error}
            </span>
          )}
          {!error && helperText && (
            <span id={`${inputId}-helper`} className="date-input-helper">
              {helperText}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default DateInput;










